import ViewWidgetSettings from "@/domain/entities/customViews/ViewWidgetSettings";
import { ViewWidgetSettings as ViewWidgetSettingsSDK } from "@cs_teamwaydev/mailvista-sdk_react";

export const viewWidgetSettingsToDomainMapper = (
    viewWidgetSettings: ViewWidgetSettingsSDK,
): ViewWidgetSettings =>
    new ViewWidgetSettings({
        showUpcomingMeetings: viewWidgetSettings.showUpcomingMeetings,
        showTodo: viewWidgetSettings.showTodo,
        showDocuments: viewWidgetSettings.showDocuments,
        showLinks: viewWidgetSettings.showLinks,
        showNotes: viewWidgetSettings.showNotes,
    });

export const viewWidgetSettingsToSDKMapper = (
    viewWidgetSettings: ViewWidgetSettings,
): ViewWidgetSettingsSDK => ({
    showUpcomingMeetings: viewWidgetSettings.showUpcomingMeetings,
    showTodo: viewWidgetSettings.showTodo,
    showDocuments: viewWidgetSettings.showDocuments,
    showLinks: viewWidgetSettings.showLinks,
    showNotes: viewWidgetSettings.showNotes,
});
